//
export default [
    {
        text        : 'sucursal',
        align       : 'left',
        sortable    : false,
        value       : 'name',
    },
    {
        text        : 'precio costo',
        align       : 'left',
        sortable    : false,
        value       : 'cost_price',
        editable    : true,
        fieldType   : 'text',
        format      : 'currency',
        width       : '200px',
    },
    {
        text        : 'precio venta',
        align       : 'left',
        sortable    : false,
        value       : 'sale_price',
        editable    : true,
        fieldType   : 'text',
        format      : 'currency',
        width       : '200px',
    },
    {
        text        : 'margen',
        align       : 'left',
        sortable    : false,
        value       : 'gains_margin',
        format      : 'percentage',
        width       : '200px',
    },
]
